import { useContext, useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { LeadsContext } from "../Context/LeadsContext";
import { getImages } from "../Const";
import { Field } from "formik";

const PhoneSearch = ({ setSelectedLeads, setAddSelectedItem, formikRef }) => {
    const { allLeads } = useContext(LeadsContext);

    const [filteredLeads,setFilteredLeads] = useState([]);

    const [showPhone, setShowPhone] = useState(false);

    const [searchText,setSearchText] = useState("");
    
    const handleSearchPhone = (e) => {
        var search = e.target.value;
        setSearchText(search);

        formikRef.current.setFieldValue("phone",search);

        //console.log(allLeads.filter((lead) => (
        //    lead.phone && lead.phone.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(search.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
        //)));

        setFilteredLeads(allLeads.filter((lead) => !lead.id.includes('SM_')).filter((lead) => (
            lead.phone && lead.phone.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(search.toLowerCase().replace(/[^a-zA-Z0-9]/g, ''))
        )));

        showLeadTimeout();
    };

    const selectLead = (selected_lead) => {
        console.log(selected_lead);

        setAddSelectedItem({
            "first_name":selected_lead?.first_name,
            "last_name":selected_lead?.last_name,
            "phone":selected_lead?.phone,
            "email":selected_lead?.email,
            "company":selected_lead?.company
        })

        setSearchText(selected_lead.phone);
        setShowPhone(false);
        setSelectedLeads(allLeads.filter((lead) => (
            lead.phone && lead.phone.toLowerCase().replace(/[^a-zA-Z0-9]/g, '').includes(selected_lead.phone.toLowerCase().replace(/[^a-zA-Z0-9]/g, '')) 
        )));
    };

    const showLeadTimeout = () => {
        setShowPhone(true);
        // setTimeout(function () {
        //     setShowPhone(false);
        // }, 5000);
    }

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            console.log('Enter key pressed');
            //getLeads();
        }
    };
    const autoCompleteRef1 = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (autoCompleteRef1.current && !autoCompleteRef1.current.contains(event.target)) {
                setShowPhone(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [allLeads]);

    useEffect(() => {
        setFilteredLeads(allLeads);
    }, [allLeads]);

    return (
        <>
            <div ref={autoCompleteRef1} className="position-relative" >
                <div>
                    <Field
                        name="phone_search"
                        type="text"
                        className='form-control'
                        onChange={handleSearchPhone}
                        value={searchText}
                        autoComplete="off"
                    />
                </div>
                <div className={`cs-search-list mob-search-list ${searchText && showPhone ? "d-none d-lg-block" : "d-none"}`} >
                    {filteredLeads.length === 0 ? (
                        <div className="autocomplete-items text-center pd-sm-title">Data not found !</div>
                    ) : (
                        filteredLeads.slice(0,5).map((option, index) => (
                            <div key={index} style={{ cursor: "pointer" }}
                                onClick={() => selectLead(option)}
                            >
                                <div className="autocomplete-items">
                                    <div className="d-flex align-items-center">
                                        <div className={"w-25 pd-xs-title " + (option.web ? "green" : "gray")}>{option?.phone}</div>
                                        <div className="w-25 pd-xs-title gray">{option?.full_name}</div>
                                        <div className="w-50 pd-xs-title text-dblue text-end">{option.email}</div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
                <div
                    className="cs-search-list mob-search-list d-lg-none" 
                    style={{
                        display: searchText && showPhone ? "block" : "none",
                    }}
                >
                    {filteredLeads.length === 0 ? (
                        <div className="autocomplete-items text-center pd-sm-title">Data not found !</div>
                    ) : (
                        filteredLeads.slice(0,5).map((option, index) => (
                            <div key={index} style={{ cursor: "pointer" }}
                                onClick={() => selectLead(option)}
                            >
                                <div className="autocomplete-items">
                                    <div className="d-flex align-items-center">
                                        <div className="w-25 pd-xs-title gray">{option?.phone}</div>
                                        <div className="w-25 pd-xs-title gray">{option?.full_name}</div>
                                        <div className="w-50 pd-xs-title text-dblue text-end">{option.email}</div>
                                    </div>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </>
    );
};

export default PhoneSearch;
